import {assert} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import {
  StructuredTableMetadata,
  TableActionFunctionParameters,
} from 'notebook/structured-tables/StructuredTableConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';

import updateStructuredTableMetadata from '../util/updateStructuredTableMetadata';
import makeSimpleActionFunction from './makeSimpleActionFunction';

export function onInvokeChangeTableDimensionLockAction<
  TTableMetadata extends StructuredTableMetadata,
  TRowMetadata,
>(
  props: Pick<
    TableActionFunctionParameters<TTableMetadata, TRowMetadata>,
    'entryOrTemplateId' | 'structuredTable' | 'performTableOpOnTable'
  >
): void {
  const {entryOrTemplateId, structuredTable, performTableOpOnTable} = props;
  assert(
    entryOrTemplateId != null,
    'ChangeTableDimensionLock action cannot be invoked outside a notebook entry'
  );

  const currentLock = structuredTable.metadata.lockRowCount;
  const newLock = !(currentLock ?? false);

  updateStructuredTableMetadata<TTableMetadata>({
    performTableOpOnTable,
    metadata: {...structuredTable.metadata, lockRowCount: newLock},
  });
}

/**
 * An ActionFunction that sets/unsets lockRowCount when toggled.
 */

export const lockTableDimensionsActionFunction = makeSimpleActionFunction({
  label: 'lock',
  icon: ({structuredTable}) => ((structuredTable.metadata.lockRowCount ?? false) ? 'lock' : 'lock-open'),
  buttonDesign: {
    buttonStyle: ButtonStyle.TRANSPARENT,
    showTextOnButton: false,
  },
  onInvoke: onInvokeChangeTableDimensionLockAction,
  getTooltip: ({structuredTable}) =>
    `${(structuredTable.metadata.lockRowCount ?? false) ? 'Unlock' : 'Lock'} table length`,
  getDisabled: ({structuredTable, locked}) => !structuredTable.isConfig || locked,
  getHidden: ({structuredTable}) => {
    // if the feature flag is on, hide the button if it's not in a template
    if (BenchlingConfig.ELN_ENABLE_TABLE_ROW_COUNT_LOCKING) {
      return !structuredTable.isConfig;
    }
    return true;
  },
});
